import { fetchFileInfo } from "actions/file";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import fileInfoSelector from "selectors/fileInfo";
import fileInfoStatusSelector from "selectors/fileInfoStatus";
import CreateJobForm from "./CreateJobForm";

interface Props {
    fileId: string;
}

const CreateJobFormLoader: React.FC<Props> = ({ fileId }) => {
    const dispatch = useDispatch();
    const status = useSelector(fileInfoStatusSelector(fileId));
    const fileInfo = useSelector(fileInfoSelector(fileId));

    React.useEffect(() => {
        switch (status) {
            case "none":
                if (!fileInfo) {
                    dispatch(fetchFileInfo(fileId));
                }
                break;
            case "notFound":
                setTimeout(() => {
                    dispatch(fetchFileInfo(fileId));
                }, 2000);
                break;
            case "loading":
                break;
            case "error":
                break;
        }
    }, [status, fileId, dispatch, fileInfo]);

    if (status === "error") {
        return <p>Error occurred loading file info. Please try again.</p>;
    }

    if (status === "notFound") {
        return (
            <p>
                File is still processing... Hold tight. This can take about a
                minute.
            </p>
        );
    }

    if (status === "loading" || !fileInfo) {
        return <p>Loading...</p>;
    }

    return <CreateJobForm fileInfo={fileInfo} />;
};

export default CreateJobFormLoader;
